// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1c3KU","tmp_img":"styles_tmp_img__10yTl","root":"styles_root__3KFJT","menu":"styles_menu__2ZqNT","dataType":"styles_dataType__2wEqd"};